import clientOrders from '@/components/client-orders/ClientOrders'

export default [
  {
    path: '/clientOrders',
    name: 'clientOrders',
    component: clientOrders,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/clientOrders.js